/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccountWiseUsage {
    getFixupPrototypeFunction() { return CloudAccountWiseUsage.fixupPrototype; }

    static newInstance(model: Partial<CloudAccountWiseUsage>): CloudAccountWiseUsage {
        let obj = Object.assign(new CloudAccountWiseUsage(), model);
        CloudAccountWiseUsage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccountWiseUsage>): CloudAccountWiseUsage {
        if (!model) return null;
        return CloudAccountWiseUsage.newInstance(<CloudAccountWiseUsage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccountWiseUsage) {
        if (!obj) return;

        models.CloudAccountWiseUsage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccountWiseUsage): boolean {
        Object.setPrototypeOf(obj, CloudAccountWiseUsage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.actual_cost === undefined) {
            this.actual_cost = 0;
        }
        if (this.forecast_cost === undefined) {
            this.forecast_cost = 0;
        }
        if (this.product_category_wise) {
            for (let val of this.product_category_wise) {
                models.ProductCategoryWiseUsage.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the cloud account
     */
    service_account_name: string;

    /**
     * Linked account ID for the cloud account
     */
    service_account_id: string;

    /**
     * Actual cost incurred for the cloud account
     */
    actual_cost: number;

    /**
     * Projected cost for the cloud account
     */
    forecast_cost: number;

    /**
     * Name of the service of the cloud account
     */
    service_name: string;

    /**
     * Type of the account
     */
    account_type: string;

    /**
     * List of category-wise usage data
     */
    product_category_wise: Array<models.ProductCategoryWiseUsage>;

}
